import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { keyBy } from 'lodash';

import {
  CompDisplayResponse,
  getCurrentPageDisplay,
} from '../../services/displayFramework';

export function useDisplayFramework(
  pagcode?: string,
  entity?: string,
  entityid?: number
) {
  const { data,refetch, isFetching, isError } = useQuery(
    ['fwDisplay', { pagcode, entity, entityid }],
    () =>
      getCurrentPageDisplay({ pagcode, entity, entityid }).then(
        (res) => res.list || []
      ),
    {
      staleTime: Infinity,
      cacheTime:12000
    }
  );

  const dataById = useMemo(() => {
    return data ? keyBy(data, 'comcode' as keyof CompDisplayResponse) : {};
  }, [data]);

  return {
    data,
    isFetching,
    isError,
    dataById,
    refetch
  };
}
